import React, { useState, useContext, useEffect, useReducer ,useRef} from 'react';
import "../../site.css";
import { AuthContext } from "../../AuthContext";
import * as FaIcons from 'react-icons/fa';
import * as BsIcons from "react-icons/bs";
import * as RiIcons from "react-icons/ri";
import { Button, Modal } from 'react-bootstrap';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getToken, saveToken } from '../Hooks/Token';
import moment from "moment";
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';
import ReCAPTCHA from 'react-google-recaptcha';

const ValidateNumber = (props) => {
    const authContext = React.useContext(AuthContext);
    const [addresses, setAddresses] = React.useState(authContext.data?.addresses.map((a, i) => ({ ...a, id: i })) ?? []);
    const [editingAddressId, setEditingAddressId] = React.useState();
    const [responseMessage, setResponseMessage] = React.useState("");
    const [userData, setUserData] = React.useState(authContext.data);
    const [address, setAddress] = React.useState();
    const [disabledButton, setDisabledButton] = React.useState(false);
    const [isValidated, setIsValidated] = React.useState(false);
    const [show, setShow] = React.useState(false);
    const { width } = useViewPort();
    const breakpoint = 520;

    async function GetUserToken(values) {
        let json = {
            username: values
        }
        const settings = {
            method: 'POST',
            type: 'no-cors',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };

        const responseCredentials = await fetch(getAPI() + `api/register/Users/getuserbyusername/`, settings)
        if (!responseCredentials.ok) {
            const resp = await responseCredentials.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const dataUser = await responseCredentials.json();
            authContext.update(dataUser);
        }
    }



    const handleEditAddress = (addressId) => {
        setEditingAddressId(addressId);
    }

    const handleDismissEdit = () => {
        setEditingAddressId(undefined);
        setResponseMessage(null);
    }

    const handleClose = () => {
        setShow(false);
        setIsValidated(undefined);
    }

    React.useEffect(() => {

    }, [addresses]);

    const handleTest = (address) => {
        SendTest(address);
    }

    async function SendTest(address) {
        let json = {
            username: authContext.data.username,
            idServiceType: address.idServiceType,
            addressValue: address.addressValue
        }

        const settings = {
            method: 'POST',
            /*            body: JSON.stringify(json),*/
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'token-captcha': address.tokencaptcha
            }
        };

        const response = await fetch(getAPI() + `api/register/Users/RequireTestMessage?username=` + authContext.data.username + `&addressValue=` + (address.idServiceType === 3 ? address.addressValue.replace(/\+/g, '%2B') : address.addressValue) + `&idservicetype=` + address.idServiceType, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            setResponseMessage(address.idServiceType === 1 ? "EMAIL Test message has been sent, you'll receive it by few minutes." : "SMS Test message has been sent, you'll receive it by few minutes.");
        }
    }

    const handleSMSCode = (address) => {
        SendSmsCode(address);
        GetUserToken(authContext.data.username);
        setDisabledButton(true);
    }

    async function SendSmsCode(address) {
        if (responseMessage !== "")
            setResponseMessage("");

        let json = {
            username: authContext.data.username,
            addressValue: address.addressValue
        }

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'token-captcha': address.tokencaptcha
            }
        };

        const response = await fetch(getAPI() + (address.idServiceType === 1 ? `api/register/Users/RequireEmailCode` : `api/register/Users/RequireSmsCode`), settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            setResponseMessage(address.idServiceType === 1
                ? <>EMAIL code has been sent, you'll receive it by few minutes.</>
                : <>SMS code has been sent, you'll receive it by few minutes. </>);
        //        : <>Our team will revise your number and will then send an SMS with the activation code that you need to include in your account to complete the registration process. If you do not receive any SMS message within 7 days, please contact <a href="https://www.gdacs.org/About/contactus.aspx" target="_blank">us</a></>);
        }
    }

    async function GetUserCode() {
        let json = {
            username: authContext.username
        }
        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + authContext.token,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        };


        const response = await fetch(getAPI() + `api/register/Users/getuserbyusername/`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const dataUser = await response.json();
            return dataUser;
        }
    }

    const handleSaveCode = async (address) => {
        const err = checkCode(address);
        if (err === "") {
            let result = await GetUserCode();
            const addressCheck = result.addresses.filter(x => x.idUserAddress === address.idUserAddress);

            if (addressCheck[0].checkcode === address.checkcode) {

                setAddresses(aa => {
                    let newAddresses = [...aa];
                    const addressIndex = newAddresses.findIndex(a => a.id === address.id);
                    newAddresses[addressIndex] = address;
                    setEditingAddressId(undefined);
                    setIsValidated(true);
                    setResponseMessage("Code inserted OK. Please click Confirm button to validate number.");
                    return newAddresses

                });
            }
            else {
                setIsValidated(false);
                setResponseMessage("Code digited is not correct.");
            }
        }
        else {
            setResponseMessage(err);
        }
    }


    const checkCode = (address) => {
        let message = "";

        if (address.idServiceType === 3 && address.checkCode !== "undefined") {
            var pattern = new RegExp(/^[0-9]*$/);
            if (!pattern.test(address.checkcode)) {
                /*                isValid = false;*/
                /*                errors["phone"] = "Please enter only number.";*/
                message = "Please enter only number.";
            } else if (address.checkcode.length !== 4) {
                /*                isValid = false;*/
                message = "The number inserted contains too many numbers. Please enter valid phone number.";
            }
        }
        return message;
    }

    const handleSubmit = (e) => {
        if (responseMessage !== "")
            setResponseMessage("");

        SaveRecord(addresses);
    }

    async function SaveRecord(addresses) {

        let addressesValidate = [];
        for (let i = 0; i < addresses.length; i++) {
            addressesValidate.push({
                idUserAddress: addresses[i].idUserAddress, idServiceType: addresses[i].idServiceType, addressOption: addresses[i].addressOption,
                deviceKey: addresses[i].deviceKey === "", addressValue: addresses[i].addressValue, checkcode: addresses[i].checkcode,
                checkvalidate: addresses[i].checkvalidate, checkdate: addresses[i].checkdate, requiretest: addresses[i].requiretest
            });
        }

        let json = {
            idUser: userData?.idUser,
            lastName: userData?.lastName,
            firstName: userData?.firstName,
            country: userData?.country,
            email: userData?.email,
            enabled: userData?.enabled,
            emailOption: userData?.emailOption,
            username: userData?.username,
            password: userData?.password,
            notes: userData?.notes,
            organisation: userData?.organisation,
            orgtype: userData?.orgtype,
            status: userData?.status,
            datemodified: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss"),
            utcOffset: userData?.utcOffset,
            addresses: addressesValidate,
            services: userData.services,
            token: userData.token
        };

        const settings = {
            method: 'POST',
            body: JSON.stringify(json),
            headers: {
                'Authorization': 'Bearer ' + getToken(),
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        }

        const response = await fetch(getAPI() + `api/register/Users/update`, settings);
        if (!response.ok) {
            const resp = await response.json();
            setResponseMessage(resp.message);
            return;
        }
        else {
            const resp = await response.json();
            authContext.update(resp);
            setShow(true);
        }
    }

    return (

        <div className="alerts_container col-12">
            <br />
            <h4 className="d-flex justify-content-center hr-title">Validate your Alert Channel</h4>
            <br />
            <div className="p_summary">
                1 - To validate your email, please click on "<b>EMAIL code</b>" button to generate the code. The Mail containing the code validator will be sent to your mail address in few seconds.<br />
                To validate the phone number, please click on "<b>SMS code</b>" button to generate the code. The SMS containing the code validator will be sent to your number in few seconds.
                </div>
            <div className="p_summary">
                2 - When you will receive the EMAIL or SMS, please click on "<b>Edit</b>" button, insert the code in the specific box, save and
                </div>
            <div className="p_summary">
                3 - Click on "<b>Confirm</b>" button to finalise the validation.
            </div>
                <br />
                <div className="p_summary">
                    The code can be generated every 6 hours
            </div>
                <br />
                <div className="p_summary">If you don't receive it please contact <a href="/About/contactus.aspx" target="_blank" >us</a ></div>
                <br />
                <br />
            <table className={width < breakpoint ? "table generic_detail_mobile" : "table generic_detail"} style={{ maxWidth: "800px"}} id="address">
                    <thead style={{ backgroundColor: "#0099CC", color: "white" }}>
                        <tr>
                            <th className="cell_hidden" >Id</th>
                            <th className="cell_hidden">IdUserAddress</th>
                            <th>Channel</th>
                            <th>Address</th>
                            <th>Check Code</th>
                            <th>Validate</th>
                            <th>Actions</th>
                            <th className="cell_hidden">Option</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            addresses.filter(x => x.idServiceType !== 10).map((address) => {
                                if (address.id === editingAddressId && address.idServiceType !== 10)
                                    return <EditingAddressRow address={address} onRequestSaveAddress={handleSaveCode} onRequestDismissEdit={handleDismissEdit}  />
                                return <AddressRow address={address} onRequestEditAddress={handleEditAddress} onRequestSentSMS={handleSMSCode} onRequestSentTest={handleTest} />
                            })
                        }
                        {
                            addresses.length === 0 &&
                            <tr>
                                <td style={{ textAlign: "center" }}>No Channel found.</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        }
                    </tbody>
                </table>
                {responseMessage &&
                    <div className="input-feedback col-12">{responseMessage}</div>
                }
                <br />
                <div style={{ paddingRight: "20px" }}>
                    <Button className="float-right btn btn-info" onClick={handleSubmit} disabled={!isValidated}>
                        Confirm
            </Button>  &nbsp;
            </div>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Validate Your Number</Modal.Title>
                    </Modal.Header>
                    <><Modal.Body>Your addresses have been checked. Now you can receive Gdacs alerts.</Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" className="float-right" onClick={handleClose}>
                                Confirm
                        </Button>
                        </Modal.Footer></>
            </Modal>
                <br />
                <br />
                <br />
                <br />
        </div>
    )
}

const EditingAddressRow = (props) => {
    const authContext = React.useContext(AuthContext);
    const [value, setValue] = React.useState();
    const [code, setCode] = React.useState(props.address.checkcode);
    const [address, setAddress] = React.useState(props.address);

    const handleChangeCode = (e) => {
        const newValue = e.currentTarget.value;
        /*        setCode(newValue);*/
        setAddress((a) => ({ ...a, checkcode: newValue, checkvalidate: true, checkdate: moment.utc().add(-6, 'hours').format("YYYY-MM-DDTHH:mm:ss") }));
        /*        setAddress((a) => ({...a, checkvalidate: true, checkdate: moment(Date.now()).add(-6, 'hours').format("YYYY-MM-DDTHH:mm:ss") }));*/
    }

    return (
            <tr>
                <td className="cell_hidden">{props.address.id}</td>
                <td className="cell_hidden">{props.address.idUserAddress}</td>
                <td style={{ textAlign: "center" }}>
                    {props.address.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : props.address.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />}
                    {/*    {props.address.idServiceType === 3 && <Telephone color="#0099CC" size={18} />}*/}
                </td>
                <td>
                    {props.address.addressValue}
                </td>
                <td>
                    <input className="input-table" name="checkcode" value={value} onChange={(e) => { handleChangeCode(e); }} />
                </td>
                <td style={{ textAlign: "center" }}>{address.checkvalidate === false || address.checkCode === null ? <RiIcons.RiCloseFill color="#FF0000" size={18} /> : <FaIcons.FaQuestion size={16} />}</td>
                <td style={{maxWidth: "310px;"}}>
                    <button type='button ' className="btn btn_table btn-primary" style={{ backgroundColor: "red" }} onClick={() => props.onRequestSaveAddress(address)}><FaIcons.FaRegSave style={{ height: '20px' }} /></button> &nbsp;
                    <button type='button ' className="btn btn_table btn-primary" style={{ backgroundColor: "#0099CC" }} onClick={() => props.onRequestDismissEdit(props.address.id)}><FaIcons.FaArrowLeft style={{ height: '20px' }} /></button>
                </td>
                <td></td>
            </tr>
    )
}

const AddressRow = (props) => {
    const authContext = React.useContext(AuthContext);
    const [address, setAddress] = React.useState(props.address);
    const [buttonDisabled, setButtonDisabled] = React.useState(false);
    const [buttonCaptchaDisabled, setButtonCaptchaDisabled] = React.useState(true);
    const { width} = useViewPort();
    const breakpoint = 620;
    const captchaRef = useRef(null);

    const onRequestSentSMS = (address) => {
        props.onRequestSentSMS(address);
        setButtonDisabled(true);
    }

    const onRequestSentTest = (address) => {
        props.onRequestSentTest(address);
    }

    const handleCaptchaChange = (e) => {
        setAddress(a => {
            a.tokencaptcha = e;
            return a;
        });
        if (address.tokencaptcha != null)
            setButtonCaptchaDisabled(false);
        else
            setButtonCaptchaDisabled(true);
    }

    return (
            <tr>
                <td className="cell_hidden">{props.address.id}</td>
            <td style={{ textAlign: "center"}} key={props.address.idServiceType}>
                    {props.address.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : props.address.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />}
                </td>
            <td >{props.address.addressValue}</td>
            <td style={{ textAlign: "center", minWidth: "80px"}}>- - - -</td>
            <td style={{ textAlign: "center"}}>{address.checkvalidate === true && address.checkcode != null ? <BsIcons.BsCheck color="#0099CC" size={18} /> :
                    address.checkvalidate === false && address.checkcode !== null ? <FaIcons.FaQuestion size={16} /> : <RiIcons.RiCloseFill color="#FF0000" size={18} />}</td>
            <td style={{ minWidth: "170px"}}>
                    {address.checkvalidate === false &&
                    <div className="col-lg-12">
                        <div className="row">
                            <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px" } : { backgroundColor: "#0099CC", }} onClick={() => props.onRequestEditAddress(props.address.id)} disabled={address.checkvalidate === true ? true : false}><FaIcons.FaRegEdit style={{ height: '20px' }} /></button> &nbsp;
                                {

                            props.address.idServiceType === 1 ?
                                <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px", height: "34px" } : { backgroundColor: "#0099CC", paddingLeft: "7px", paddingRight: "7px", }} onClick={() => onRequestSentSMS(address)} disabled={buttonCaptchaDisabled || buttonDisabled || (address.checkvalidate === true ? true : false)} >{breakpoint > width ? <Envelope size={18} /> : "EMAIL Code"}</button>
                            :
                            <button type='button'
                                className="btn btn_table btn-primary"
                                style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px", height: "34px" } : { backgroundColor: "#0099CC", }}
                                onClick={() => onRequestSentSMS(address)}
                                disabled={buttonCaptchaDisabled || buttonDisabled || (address.checkvalidate === true ? true : false)} >{breakpoint > width ? <Telephone size={18} /> : "SMS Code"}</button>
                            }
                        </div>
                        </div>
                    }
                    {address.checkvalidate === true &&
                    <button type='button ' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px", height: "34px" } : { backgroundColor: "#0099CC", }} onClick={() => onRequestSentTest(address)} disabled={buttonCaptchaDisabled || (address.checkvalidate === false || address.checkvalidate === null ? true : false)} >Test</button>
                    }
                </td>
                <td style={{ maxWidth: "260px" }}>
                        <>

                            <form className="captcha">
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_SITE_KEY}
                                    ref={captchaRef}
                                onChange={handleCaptchaChange}
                            />
                        </form>
                        </>
                </td>
            </tr>
    )
}

export { ValidateNumber};